import { useRef, useState } from "react";
import Loadable from "react-loadable";
import { Route, Routes } from "react-router-dom";
import { GetCurrentUser } from "../utills/DefaultFunction.js";
import Main from "../components/layout/Main.js";
import SignIn from "../pages/SignIn.js";
import AuthorizedRoute from "./AuthorizedRoute";
import ProtectedRoutes from "./ProtectedRoutes";

const AppRoutes = () => {
  const ref = useRef(null);
  const user = GetCurrentUser();
  const [progress, setProgress] = useState(0);
  const Loading = () => "loading";

  const createLoadableComponent = (importFunction) => {
    return Loadable({
      loader: importFunction,
      loading: Loading,
    });
  };
  // route components using lazy loading
  const routes = [
    {
      path: "/dashboard",
      component: createLoadableComponent(() => import("../pages/Home.js")),
    },
    {
      path: "/tables",
      component: createLoadableComponent(() => import("../pages/Tables.js")),
    },
    {
      path: "/billing",
      component: createLoadableComponent(() => import("../pages/Billing.js")),
    },
    {
      path: "/profile",
      component: createLoadableComponent(() => import("../pages/Profile.js")),
    },
    {
      path: "/country",
      component: createLoadableComponent(() =>
        import("../pages/Configuration/Country.jsx")
      ),
    },
    {
      path: "/city",
      component: createLoadableComponent(() =>
        import("../pages/Configuration/City.jsx")
      ),
    },
    {
      path: "/state",
      component: createLoadableComponent(() =>
        import("../pages/Configuration/State.jsx")
      ),
    },
    {
      path: "/industry",
      component: createLoadableComponent(() =>
        import("../pages/Configuration/Industry.jsx")
      ),
    },
    {
      path: "/qualification",
      component: createLoadableComponent(() =>
        import("../pages/Configuration/Qualification.jsx")
      ),
    },
    {
      path: "/skill",
      component: createLoadableComponent(() =>
        import("../pages/Configuration/Skill.jsx")
      ),
    },
    {
      path: "/job-role",
      component: createLoadableComponent(() =>
        import("../pages/Configuration/JobRole.jsx")
      ),
    },
    {
      path: "/client",
      component: createLoadableComponent(() =>
        import("../pages/Client/Client.jsx")
      ),
    },
    {
      path: "/client/add",
      component: createLoadableComponent(() =>
        import("../pages/Client/AddClient.jsx")
      ),
    },
    {
      path: "/client/update",
      component: createLoadableComponent(() =>
        import("../pages/Client/UpdateClient.jsx")
      ),
    },
    {
      path: "/candidate",
      component: createLoadableComponent(() =>
        import("../pages/Candidate/Candidate.jsx")
      ),
    },
    {
      path: "/candidate/add",
      component: createLoadableComponent(() =>
        import("../pages/Candidate/AddCandidate.jsx")
      ),
    },
    {
      path: "/candidate/update",
      component: createLoadableComponent(() =>
        import("../pages/Candidate/UpdateCandidate.jsx")
      ),
    },
    {
      path: "/candidate/view",
      component: createLoadableComponent(() =>
        import("../pages/Candidate/ViewCandidate.jsx")
      ),
    },
    {
      path: "/documents",
      component: createLoadableComponent(() =>
        import("../pages/Document/Documents.jsx")
      ),
    },
    {
      path: "/documents/view",
      component: createLoadableComponent(() =>
        import("../pages/Document/ViewDocument.jsx")
      ),
    },
    {
      path: "/invoice-template",
      component: createLoadableComponent(() =>
        import("../pages/Template/InvoiceTemplate.jsx")
      ),
    },
    {
      path: "/mapping-ui",
      component: createLoadableComponent(() =>
        import("../pages/Mapping/FieldMappingUI.jsx")
      ),
    },
    {
      path: "/mapping-interface",
      component: createLoadableComponent(() =>
        import("../pages/Mapping/MappingInterface.jsx")
      ),
    },
    {
      path: "/builder",
      component: createLoadableComponent(() =>
        import("../pages/Builder/InvoiceBuilder.jsx")
      ),
    },
    {
      path: "/templates",
      component: createLoadableComponent(() =>
        import("../pages/Template/Templates.jsx")
      ),
    },
    {
      path: "/templates/create-template",
      component: createLoadableComponent(() =>
        import("../pages/Template/CreateTemplate.jsx")
      ),
    },

    {
      path: "/templates/view-template/edit",
      component: createLoadableComponent(() =>
        import("../pages/Template/CreateTemplate.jsx")
      ),
    },
    {
      path: "/vendor-mapping",
      component: createLoadableComponent(() =>
        import("../pages/Mapping/VendorMapping.jsx")
      ),
    },
  ];

  return (
    <>
      {/* <BrowserRouter> */}
      {/* <TopLoadingBar /> */}
      {/* <LoadingBar ref={ref} height={5} color="#F40009" /> */}
      <Routes>
        <Route path="/" element={<SignIn />} />
        <Route element={<ProtectedRoutes />}>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <Main>
                  <route.component />
                </Main>
              }
              // exact
            />
          ))}
        </Route>
      </Routes>
      {/* </BrowserRouter> */}
    </>
  );
};

export default AppRoutes;
